export const adminItemStatus = [
  {
    status: 'shopped',
    progress: '30',
    statusText: 'Awaiting shipped notification',
  },
  {
    status: 'shipped-to-gyb',
    progress: '30',
    statusText: 'Awaiting Mark as Received notification',
  },
  {
    status: 'received-by-gyb',
    progress: '60',
    statusText: 'Awaiting Mark as Sent notification',
  },
  {
    status: 'shipped-to-shopper',
    progress: '80',
    statusText: 'Shipped to shopper',
  },
];

export const adminAllItemStatus = [
  {
    status: 'in-shop',
    progress: '25',
    statusText: 'Available to shop',
  },
  {
    status: 'shopped',
    progress: '50',
    statusText: 'Shopped',
  },
  {
    status: 'shipped-to-gyb',
    progress: '75',
    statusText: 'Shipped to Give Your Best',
  },
  {
    status: 'received-by-gyb',
    progress: '75',
    statusText: 'Received by Give your Best',
  },
  {
    status: 'shipped-to-shopper',
    progress: '75',
    statusText: 'Shipped to shopper',
  },
  {
    status: 'received',
    progress: '100',
    statusText: 'Received by shopper',
  },
];

export const donorItemStatus = [
  {
    status: 'shopped',
    progress: '30',
    statusText: 'Awaiting Mark as Sent notification',
  },
  {
    status: 'shipped-to-gyb',
    progress: '60',
    statusText: 'Awaiting Mark as Received notification',
  },
  {
    status: 'received-by-gyb',
    progress: '60',
    statusText: 'Awaiting Mark as Received notification',
  },
  {
    status: 'shipped-to-shopper',
    progress: '60',
    statusText: 'Awaiting Mark as Received notification',
  },
];

export const shopperItemStatus = [
  {
    status: 'shopped',
    progress: '30',
    statusText: 'Processing',
  },
  {
    status: 'shipped-to-gyb',
    progress: '30',
    statusText: 'Processing',
  },
  {
    status: 'received-by-gyb',
    progress: '30',
    statusText: 'Processing',
  },
  {
    status: 'shipped-to-shopper',
    progress: '60',
    statusText: 'On its way',
  },
  {
    status: 'received',
    progress: '100',
    statusText: 'Received by you!',
  },
];
